"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var NavigationContainer_exports = {};
__export(NavigationContainer_exports, {
  NavigationContainer: () => NavigationContainer
});
module.exports = __toCommonJS(NavigationContainer_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_core = require("@react-navigation/core");
var import_native = require("@react-navigation/native");
var React = __toESM(require("react"), 1);
var import_use_latest_callback = __toESM(require("use-latest-callback"), 1);
var import_localeDirection = require("./localeDirection");
var import_theme = require("./theme");
var import_useBackButton = require("./useBackButton");
var import_useDocumentTitle = require("./useDocumentTitle");
var import_useLinking = require("./useLinking");
var import_useThenable = require("./useThenable");
globalThis.REACT_NAVIGATION_DEVTOOLS = /* @__PURE__ */ new WeakMap();
function NavigationContainerInner(param, ref) {
  var { direction = (0, import_localeDirection.getLocaleDirection)(), theme = import_theme.DefaultTheme, linking, fallback = null, documentTitle, onReady, onStateChange, ...rest } = param;
  var isLinkingEnabled = linking ? linking.enabled !== false : false;
  if (linking === null || linking === void 0 ? void 0 : linking.config) {
    (0, import_core.validatePathConfig)(linking.config);
  }
  var refContainer = React.useRef(null);
  (0, import_useBackButton.useBackButton)(refContainer);
  (0, import_useDocumentTitle.useDocumentTitle)(refContainer, documentTitle);
  var [lastUnhandledLink, setLastUnhandledLink] = React.useState();
  var { getInitialState } = (0, import_useLinking.useLinking)(refContainer, {
    enabled: isLinkingEnabled,
    prefixes: [],
    ...linking
  }, setLastUnhandledLink);
  var linkingContext = React.useMemo(function() {
    return {
      options: linking
    };
  }, [
    linking
  ]);
  var unhandledLinkingContext = React.useMemo(function() {
    return {
      lastUnhandledLink,
      setLastUnhandledLink
    };
  }, [
    lastUnhandledLink,
    setLastUnhandledLink
  ]);
  var onReadyForLinkingHandling = (0, import_use_latest_callback.default)(function() {
    var _refContainer_current_getCurrentRoute, _refContainer_current;
    var path = (_refContainer_current = refContainer.current) === null || _refContainer_current === void 0 ? void 0 : (_refContainer_current_getCurrentRoute = _refContainer_current.getCurrentRoute()) === null || _refContainer_current_getCurrentRoute === void 0 ? void 0 : _refContainer_current_getCurrentRoute.path;
    setLastUnhandledLink(function(previousLastUnhandledLink) {
      if (previousLastUnhandledLink === path) {
        return void 0;
      }
      return previousLastUnhandledLink;
    });
    onReady === null || onReady === void 0 ? void 0 : onReady();
  });
  var onStateChangeForLinkingHandling = (0, import_use_latest_callback.default)(function(state) {
    var _refContainer_current_getCurrentRoute, _refContainer_current;
    var path = (_refContainer_current = refContainer.current) === null || _refContainer_current === void 0 ? void 0 : (_refContainer_current_getCurrentRoute = _refContainer_current.getCurrentRoute()) === null || _refContainer_current_getCurrentRoute === void 0 ? void 0 : _refContainer_current_getCurrentRoute.path;
    setLastUnhandledLink(function(previousLastUnhandledLink) {
      if (previousLastUnhandledLink === path) {
        return void 0;
      }
      return previousLastUnhandledLink;
    });
    onStateChange === null || onStateChange === void 0 ? void 0 : onStateChange(state);
  });
  React.useEffect(function() {
    if (refContainer.current) {
      REACT_NAVIGATION_DEVTOOLS.set(refContainer.current, {
        get linking() {
          var _ref, _ref1, _ref2, _ref3;
          return {
            ...linking,
            enabled: isLinkingEnabled,
            prefixes: (_ref = linking === null || linking === void 0 ? void 0 : linking.prefixes) !== null && _ref !== void 0 ? _ref : [],
            getStateFromPath: (_ref1 = linking === null || linking === void 0 ? void 0 : linking.getStateFromPath) !== null && _ref1 !== void 0 ? _ref1 : import_core.getStateFromPath,
            getPathFromState: (_ref2 = linking === null || linking === void 0 ? void 0 : linking.getPathFromState) !== null && _ref2 !== void 0 ? _ref2 : import_core.getPathFromState,
            getActionFromState: (_ref3 = linking === null || linking === void 0 ? void 0 : linking.getActionFromState) !== null && _ref3 !== void 0 ? _ref3 : import_core.getActionFromState
          };
        }
      });
    }
  });
  var [isResolved, initialState] = (0, import_useThenable.useThenable)(getInitialState);
  if (process.env.ONE_DEBUG_ROUTER) {
    console.info(`[one] \u{1F3E0} NavigationContainer isResolved=${isResolved} initialState=`, JSON.stringify(initialState, null, 2));
    console.info(`[one] \u{1F3E0} NavigationContainer rest.initialState=`, rest.initialState);
  }
  React.useImperativeHandle(ref, function() {
    return refContainer.current;
  });
  var isLinkingReady = rest.initialState != null || !isLinkingEnabled || isResolved;
  if (!isLinkingReady) {
    return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_core.ThemeProvider, {
      value: theme,
      children: fallback
    });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_native.LocaleDirContext.Provider, {
    value: direction,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_native.UNSTABLE_UnhandledLinkingContext.Provider, {
      value: unhandledLinkingContext,
      children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_native.LinkingContext.Provider, {
        value: linkingContext,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_core.BaseNavigationContainer, {
          ...rest,
          theme,
          onReady: onReadyForLinkingHandling,
          onStateChange: onStateChangeForLinkingHandling,
          initialState: rest.initialState == null ? initialState : rest.initialState,
          ref: refContainer
        })
      })
    })
  });
}
var NavigationContainer = /* @__PURE__ */ React.forwardRef(NavigationContainerInner);
//# sourceMappingURL=NavigationContainer.js.map
